// extracted by mini-css-extract-plugin
module.exports = {"detailPanel":"antd-pro-pages-editor-mind-components-editor-detail-panel-index-detailPanel"};